export const options_tagtype_zeus = [
  // 初期リリース時はタグアセット画像は未対応
  // {value: '1', label: 'タグアセット(画像)'},
  {value: '2', label: 'タグアセット(動画)'},
];

export const options_size_zeus = [
  { label: '320×180', value: { width: 320, height: 180 } },
  { label: '300×250', value: { width: 300, height: 250 } },
  { label: '320×100', value: { width: 320, height: 100 } },
  { label: '320×50', value: { width: 320, height: 50 } },
  { label: '336×280', value: { width: 336, height: 280 } },
  // 必要に応じて追加
];